import { AgGrid } from "@jsq/ds/core";
import { FundRow } from "./types";

/**
 * List of the supported columns in the Funds table
 * (ordered from left to right)
 */
export enum SupportedColumns {
  FundName = "name",
  Client = "arenaName",
}

/**
 * The mapper provides the corresponding column name displayed in the table
 */
export const columnNames = new Map<SupportedColumns, string>([
  [SupportedColumns.FundName, "Fund Name"],
  [SupportedColumns.Client, "Client"],
]);

/**
 * AG Grid Column definitions for the Funds Table
 */
export const columnDefinitions: AgGrid.ColDef<FundRow>[] = [
  {
    field: SupportedColumns.FundName,
    headerName: columnNames.get(SupportedColumns.FundName),
    pinned: "left",
    minWidth: 360,
    filter: true,
    sortable: true,
    resizable: false,
  },
  {
    field: SupportedColumns.Client,
    headerName: columnNames.get(SupportedColumns.Client),
    menuTabs: ["generalMenuTab", "columnsMenuTab"],
    filter: true,
    sortable: true,
    resizable: false,
  },
];
